module.exports = __webpack_public_path__ + "img/icon-clipboard-white.00fea0ec.svg";